import { render, staticRenderFns } from "./McIconPicker.vue?vue&type=template&id=4486edcc"
import script from "./McIconPicker.vue?vue&type=script&lang=js"
export * from "./McIconPicker.vue?vue&type=script&lang=js"
import style0 from "./McIconPicker.vue?vue&type=style&index=0&id=4486edcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports